import { FC } from 'react'

import { Icon } from '..'

type AlertProps = {
  className?: string,
  style?: any,
  type?: 'INFO' | '',
  color?: string,
  align?: 'left' | 'center' | 'right' | '',
  icon?: string
}

const Alert:FC<AlertProps> = ({ className = '', children, color = 'info', align = '', icon, type, style }) => {
  const getIcon = (): string => {
    if(icon) {
      return icon
    } else if(type === 'INFO') {
      return 'alert-info'
    }
    return ''
  }

  return (
    <div className={`p-10 px-20 ${type || icon ? 'd-flex align-items-center' : ''} ${color ? 'bg-' + color : ''} ${align ? 'text-' + align : ''}  ${className}`} style={{ borderRadius: 4, ...style}}>
      {(type || icon) &&
        <Icon name={getIcon()} className="mr-10" />
      }
      {children}
    </div>
  )
}
export { Alert }